import React from 'react';
export function TechSpecsBandSection() {
  return <div className="bg-brand-dark text-white py-16" data-id="element-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-801">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center" data-id="element-802">
          <div className="p-4" data-id="element-803">
            <div className="text-brand-yellow font-bold text-4xl mb-2" data-id="element-804">
              60 PSI
            </div>
            <div className="text-gray-400" data-id="element-805">Automatic Shutoff</div>
          </div>
          <div className="p-4 border-y md:border-y-0 md:border-x border-gray-700" data-id="element-806">
            <div className="text-brand-yellow font-bold text-4xl mb-2" data-id="element-807">
              75 FT
            </div>
            <div className="text-gray-400" data-id="element-808">Reinforced Hose</div>
          </div>
          <div className="p-4" data-id="element-809">
            <div className="text-brand-yellow font-bold text-4xl mb-2" data-id="element-810">
              110V
            </div>
            <div className="text-gray-400" data-id="element-811">Corded Electric Power</div>
          </div>
        </div>
      </div>
    </div>;
}